import { render, staticRenderFns } from "./advertisement.vue?vue&type=template&id=18c0a5b6&"
import script from "./advertisement.vue?vue&type=script&lang=js&"
export * from "./advertisement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {PagesAboutExtentionsIntro: require('/home/webuser/www/megasreda/frontend-v2/releases/20240313112438/components/Pages/About/Extentions/Intro.vue').default,MegastudioTariffsComparisonTableOneTimeTable: require('/home/webuser/www/megasreda/frontend-v2/releases/20240313112438/components/Megastudio/Tariffs/Comparison/Table/OneTimeTable.vue').default,PagesAboutExtentionsBusinessCreateProfile: require('/home/webuser/www/megasreda/frontend-v2/releases/20240313112438/components/Pages/About/Extentions/Business/Create/Profile.vue').default,PagesAboutExtentionsForm: require('/home/webuser/www/megasreda/frontend-v2/releases/20240313112438/components/Pages/About/Extentions/Form.vue').default,PagesAboutExtentionsLayout: require('/home/webuser/www/megasreda/frontend-v2/releases/20240313112438/components/Pages/About/Extentions/Layout/index.vue').default})
